import { create } from "zustand";

type ConnectionState = {
  online: boolean;
  /** Last time any request reached the server. */
  lastContact: number | null;
  markOffline: () => void;
  markContact: () => void;
};

export const useConnection = create<ConnectionState>((set, get) => ({
  online: typeof navigator === "undefined" ? true : navigator.onLine,
  lastContact: null,
  markOffline: () => get().online && set({ online: false }),
  markContact: () => set({ online: true, lastContact: Date.now() }),
}));

if (typeof window !== "undefined") {
  window.addEventListener("offline", () => useConnection.setState({ online: false }));
  // "online" only means a network interface came back; the next request confirms it.
  window.addEventListener("online", () => useConnection.setState({ online: true }));
}
